import React from "react";
import { useState, useEffect } from "react";
import AuthService from "../services/auth.service";
import api from "../services/api";
import { Link, useNavigate, useParams } from "react-router-dom";
import TopBar from "../components/TopBar";

function NewMilk() {
  const [startDate, setStartDate] = useState(new Date().toISOString().substring(0, 10));
  const [endDate, setEndDate] = useState(new Date().toISOString().substring(0, 10));
  const [quantity, setQuantity] = useState("");
  const [adLibitum, setAdLibitum] = useState(false);
  const [calf, setCalf] = useState({});
  const navigate = useNavigate();
  let { id } = useParams();

  const getCalf = () => {
    api.get("/calfs/" + id)
      .then((response) => {
        const data = response.data;
        setCalf(data);
      })
      .catch((error) => {
        console.error("There was an error getting the calf!", error);
      });
  };

  const handleSubmit = (event) => {
    // prevents the submit button from refreshing the page
    event.preventDefault();
    let parsedQuantity = parseFloat(quantity.replace(",", "."));

    api.post("/milk", {
      startDate: startDate,
      endDate: endDate,
      quantity: parsedQuantity,
      calfID: id,
      adLibitum: adLibitum,
    })
      .then(() => {
        navigate("/veaux/" + id + "?view=milk");
      })
      .catch((error) => {
        console.error("There was an error creating milk record!", error);
      });
  };

  useEffect(() => {
    //Runs only on the first render
    const currentUser = AuthService.getCurrentUser();
    if (!currentUser) {
      navigate("/login");
    } else {
      getCalf();
    }
  }, []);

  return (
    <div>
      <TopBar link={"/veaux/" + id + "?view=milk"}></TopBar>
      <div className="mx-3 px-3 pt-2 bg-white rounded-lg dark:bg-slate-900 dark:border-slate-700 dark:text-white dark:border">
        <div className="flex flex-col mb-3">
          <span className="font-bold text-2xl">Ajouter du lait</span>
          <p className="text-sm text-stone-400">
            Vous pouvez ajouter une nouvelle quantité de lait ici.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col w-full">
          <label
            htmlFor="startDate_input"
            className="text-sm font-medium text-stone-700 dark:text-white"
          >
            Date de début
          </label>
          <input
            className="w-full border border-stone-300 bg-stone-100 rounded-lg mb-3 p-3 text-stone-500 dark:border-slate-700 dark:bg-slate-800 dark:text-white"
            type="date"
            defaultValue={new Date().toISOString().substring(0, 10)}
            onChange={(e) => setStartDate(e.target.value)}
            placeholder="Date de début"
            name="startDate_input"
          ></input>

          <label
            htmlFor="endDate_input"
            className="text-sm font-medium text-stone-700 dark:text-white"
          >
            Date de fin
          </label>
          <input
            className="w-full border border-stone-300 bg-stone-100 rounded-lg mb-3 p-3 text-stone-500 dark:border-slate-700 dark:bg-slate-800 dark:text-white"
            type="date"
            defaultValue={new Date().toISOString().substring(0, 10)}
            onChange={(e) => setEndDate(e.target.value)}
            placeholder="Date de fin"
            name="endDate_input"
          ></input>

          <label
            htmlFor="adLibitum_input"
            className="text-sm font-medium text-stone-700 dark:text-white"
          >
            Ad libitum
          </label>

          <input
            className="w-4 h-4 mb-3 text-amber-600 bg-stone-100 border-stone-300 rounded focus:ring-amber-500 dark:focus:ring-amber-600 dark:ring-offset-stone-800 focus:ring-2 dark:bg-slate-700 dark:border-slate-600"
            type="checkbox"
            checked={adLibitum}
            onChange={(e) => {
              setAdLibitum(e.target.checked);
              if (e.target.checked) {
                setQuantity("12");
              } else {
                setQuantity("");
              }
            }}
            name="adLibitum_input"
          ></input>

          <label
            htmlFor="quantity_input"
            className="text-sm font-medium text-stone-700 dark:text-white"
          >
            Quantité de lait (kg)
          </label>
          <input
            className="w-full border border-stone-300 bg-stone-100 rounded-lg mb-3 p-3 text-stone-500 dark:border-slate-700 dark:bg-slate-800 dark:text-white disabled:opacity-50 disabled:cursor-not-allowed"
            type="text"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            placeholder="Quantité en kilos"
            name="quantity_input"
            disabled={adLibitum}
          ></input>

          <button
            type="submit"
            className="bg-amber-400 text-white font-medium rounded-lg mb-3 w-full my-3 p-3 dark:border-slate-700 dark:bg-amber-600 dark:text-white"
          >
            Ajouter
          </button>
          <Link to={"/veaux/" + id + "?view=milk"}>
            <button className="bg-stone-200 text-stone-700 font-medium rounded-lg mb-3 w-full my-3 p-3 dark:border-slate-700 dark:bg-slate-800 dark:text-white">
              Annuler
            </button>
          </Link>
        </form>
      </div>
    </div>
  );
}

export default NewMilk; 